export interface TryonResource {
  pose: number
  url: string
}
export interface ApiResponse<T> {
  result?: T
  errorCode?: string
  errorMessage?: string
}

const LocalData = {
  async tryOnModelV0(patientId: string, sku: string): Promise<ApiResponse<TryonResource[]>> {
    let rawJSON

    try {
      const res = await fetch(`/data/${patientId}.json`,
        {
          headers: { 
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Content-Encoding': 'gzip, deflate, br'
          }
        }
      )
      const rawData = await res!.text()
      rawJSON = JSON.parse(rawData)
    } catch (e) {
      console.log(e)

      return {
        errorCode: 'ENOPATINENT',
        errorMessage: 'errNoPatient'
      }
    }

    if (rawJSON && rawJSON[sku]) {
      return {
        result: rawJSON[sku].assets
      }
    } else {
      return {
        errorCode: 'ENOASSETS',
        errorMessage: 'errNoAssets'
      }
    }
  }
}

export default LocalData
